<!-- <ion-header [translucent]="true">
<ion-toolbar>
  <ion-buttons slot="start">
    <ion-menu-button></ion-menu-button>
  </ion-buttons>
  <ion-title>registration-confirmation</ion-title>
</ion-toolbar>
</ion-header> -->
<ion-content [fullscreen]="true">
  <div class="welcomePopup">
    <ion-grid>
      <ion-row>
        <ion-col>
          <!-- Main content wrapper starts here -->
          <div class="ion-align-self-center main-container">
            <div class="ion-text-center ion-margin-top">
              <img class="check-icon" src="assets/images/check.svg" alt="Success" /><!-- Succes Image -->
            </div>
            <ion-text class="register-text">
              <!-- App heading and description starts here -->
              <h1>{{ "registration-confirmation.Account" | translate }}</h1>
              <p class="ion-text-center">
                {{ "registration-confirmation.Congratulations" | translate }}<br /><br />
              </p>
              @if (showExtraContent) {
                <div class="ion-text-center">
                  <p>
                    {{ "registration-confirmation.FreeLines" | translate }}
                  </p>
                  <p class="text-bold">
                    {{ "registration-confirmation.AgeVerification" | translate }}
                  </p>
                </div>
              }
            </ion-text>
            <!-- App heading and description closed here -->
            <!-- App button starts here -->
            <app-auto-click-button
              (buttonClick)="callInt1()"
              [buttonText]="'registration-confirmation.Let' | translate"
              [resetKey]="ctaResetKey"
              [delay]="500"
            ></app-auto-click-button>
            @if (continueError) {
              <p class="ion-text-center continue-error">
                {{ "registration-confirmation.continue_failed" | translate }}
              </p>
            }
          </div>
          <!-- Main content wrapper closed here -->
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
